

export default {
  SHOW_LOGIN_BOX(state, data = {}) {
    state.showLoginBox = true;
    state.loginBoxPage = data.page || 1;
    state.loginFrom = data.from || '';
    state.loginNotReload = data.notReload || false;
  },
  CLOSE_LOGIN_BOX(state) {
    state.showLoginBox = false;
  },
  CHANGE_LOGIN_BOX_PAGE(state, page = 1) {
    state.loginBoxPage = page;
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js